export default {
  27: 'Alimentação',
  28: 'Auto',
  30: 'Cultura',
  31: 'Refeição',
  58: 'Home Office',
  201: 'Alimentação Cesta',
  202: 'Boas Festas',
  203: 'Compras',
  204: 'Auxílio Alimentação',
  207: 'Multibenefícios',
  208: 'Multibeneficios Plus',
  209: 'VR+VA',
  211: 'Auxílio Alimentação Multi Saldo',
  212: 'Alimentação PAT Multi Saldo',
  213: 'VR Flex (VR+VA) Multi Saldo',
  243: 'Auxílio Refeição',
  244: 'Refeição PAT Multi Saldo',
  245: 'Auxílio Refeição Multi Saldo',
  262: 'Auto Multi Saldo',
  271: 'Auxílio Refeição',
  272: 'Refeição PAT Multi Saldo',
  291: 'Auxílio Alimentação',
  292: 'Auxílio Mult',
  293: 'Alimentação PAT Multi Saldo',
  681: 'Transporte',

  270: 'Refeição',
  290: 'Alimentação',
  294: 'Multibenefícios',
};
